<template>
  <div class="select-identity">
    <div class="title">您是？</div>
    <div class="title-message">同是车主和驾驶员请选择车主身份</div>
    <div class="identity-list flex">
      <div class="identity-item"  @click="identityChange(item)" v-for="item in identityData" :key="item.id">
        <div class="img-box">
          <img class="identity-item-img" :src="item.imgpath" alt="" srcset="">
          <img :src="item | selectImg" class="select-img" alt="" srcset="">
        </div>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
    <div class="other flex" @click="otherChange">
      <img :src="otherData | selectImg" alt="" srcset="">
      <div>{{ otherData.identity }}</div>
    </div>
    <div class="tips">请准确选择身份，以便为您提供更好服务</div>
    <div class="btn" @click="showConfirmDialog">确认</div>
    <van-action-sheet
      :close-on-click-overlay="false"
      v-model="showActionSheet"
      :round="false"
      :actions="actionsData"
      @select="onSelectSheet" />
    <confirm-dialog
      :title="'请再次核实身份'"
      :cancelButtonText="'修改'"
      :confirmButtonText="'确定'"
      :message="confirmDialogMessage"
      @confirm="confirmBtn"
      ref="ConfirmDialog">
    </confirm-dialog>
  </div>
</template>

<script>
// import { identityData } from '../../utils/attestation'
import IconSelect from '../../assets/images/attestation/select.png'
import IconUnSelect from '../../assets/images/attestation/unselect.png'
import ConfirmDialog from '../../components/dialog/ConfirmDialog'
import { wxRaLunch } from '../../utils/WeChatUtil'
import { getIdentityInfo, updateIdentityInfo } from '../../api/attestation'
import { filterIdentificationImg } from '../../utils/attestation'
import { Toast } from 'vant'
export default {
  props: {},
  data() {
    return {
      identityData: [], // 车主身份数据
      otherData: {
        id: 7,
        identity: '其他身份',
        iconLink: null,
        is_active: false
      },
      select_id: null, // 用户选择的身份的ID
      select_pid: 1, // 用户选择的身份有多层的父级id
      actionsData: [], // 二级目录显示的数据
      showActionSheet: false, // 上拉菜单是否显示
      confirmDialogMessage: '注：您后续可以在个人中心完成<br/>认证，获得票数奖励。'
    };
  },
  computed: {},
  components: {
    ConfirmDialog
  },
  filters: {
    /**
     *
     *
     * 过滤选择的图片
    */
    selectImg(item) {
      return item.is_active ? IconSelect : IconUnSelect
    },
  },
  async created() {
    await this.getidentificationData()
  },
  mounted() {},
  watch: {},
  methods: {
    /**
     *
     * @param {*} data 每一项身份数据
     *
     * 选择身份改变事件
    */
    identityChange(data) {
      const { is_active } = this.otherData
      if (is_active) {
        this.otherData.is_active = false
      }
      const { id } = data
      this.select_id = id
      this.identityData.forEach(item => {
        item.is_active = item.id === id
      })
      if (data.children.length) {
        this.showActionSheet = true
        this.select_pid = id
        this.actionsData = data.children
      }
    },

    /**
     *
     *
     * 选择其他身份
    */
    otherChange() {
      this.select_id = 7
      this.otherData.is_active = true
      this.identityData.forEach(item => {
        item.is_active = false
      })
    },

    /**
     *
     *
     * 获取可选的身份列表
    */
    async getidentificationData() {
      const response = await getIdentityInfo()
      if (response.success) {
        let { identities, currentIdentityId } = response.data
        this.select_id = currentIdentityId
        currentIdentityId = currentIdentityId || 0
        identities = identities.filter(item => item.id !== 7)
        this.identityData = identities.map(item => {
          if ((currentIdentityId === 5 || currentIdentityId === 6) && item.id === 4) {
            // 当用户选择是工厂或者发货企业的时候，给父级选中
            item.is_active = true
          } else {
            item.is_active = item.id === currentIdentityId
          }
          item.name = item.identity
          item.imgpath = filterIdentificationImg(item.id)
          if (item.children && item.children.length) {
            item.children.forEach(ele => {
              ele.name = ele.identity
            })
          }
          return item
        })
        if (currentIdentityId === 7) {
          this.otherData.id = currentIdentityId
          this.otherData.is_active = true
        }
      }
    },

    showConfirmDialog() {
      if (!this.select_id) {
        Toast('请先勾选身份')
        return
      }
      this.$refs.ConfirmDialog.showPopup()
    },

    /**
     *
     *
     * 确定选择身份
    */
    async confirmBtn() {
      console.log(this.select_id)
      const response = await updateIdentityInfo({ identityId: this.select_id })
      if (response.success) {
        if (this.isWechart) {
          wxRaLunch('/pages/index/index')
        } else {
          // 安卓和苹果客户端
          window.location.href = 'https://www.success.selectidentity/'
        }
      }
    },

    /**
     *
     * @param data 可以选择的每一项数据
     *
     * 上拉菜单选择弹框
    */
    onSelectSheet(data) {
      this.identityData.forEach(item => {
        if (item.id === this.select_pid) {
          item.name = data.name
        }
      })
      this.select_id = data.id
      this.showActionSheet = false
      this.actionsData = []
    }
  }
};
</script>

<style scoped lang="scss">
.select-identity {
  text-align: center;
  .title {
    color: #282828;
    font-size: 36px;
    padding-top: 60px;
    font-weight: bold;
  }
  .title-message {
    color: #989898;
    font-size: 22px;
    padding-top: 20px;
  }
  .identity-list {
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 30px;
    .identity-item {
      width: 265px;
      height: 265px;
      border-radius: 6px;
      background-color: #FFFFFF;
      margin-bottom: 20px;
      .img-box {
        width: 140px;
        margin: 30px auto;
        position: relative;
        .identity-item-img {
          width: 100%;
        }
        .select-img {
          width: 30px;
          position: absolute;
          bottom: 4px;
          right: 4px;
        }
      }
      .name {
        text-align: center;
        color: #282828;
        font-size: 24px;
        font-weight: bold;
      }
    }
    .identity-item:nth-child(2n+2) {
      margin-left: 20px;
    }
  }
  .other {
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 20px;
    img {
      width: 30px;
    }
    div {
      padding-left: 20px;
      color: #282828;
      font-size: 24px;
      font-weight: bold;
    }
  }
  .tips {
    color: #989898;
    font-size: 22px;
    padding-bottom: 20px;
  }
  .btn {
    background-color: #5572FD;
    border-radius: 3px;
    height: 80px;
    width: 420px;
    margin: 0 auto;
    text-align: center;
    color: #FFFFFF;
    font-size: 28px;
    line-height: 80px;
  }
}
</style>
